<script setup>
import SectionHero from '@/components/SectionHero.vue';

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';

import {useRouting} from "@/composables/routing.js";
import SectionHalfText from "@/components/SectionHalfText.vue";
import SectionTextWithFlatCards from "@/components/SectionTextWithFlatCards.vue";
import SectionSimpleText from "@/components/SectionSimpleText.vue";
import SectionTextWithAccordion from "@/components/SectionTextWithAccordion.vue";
const {href, url} = useRouting();

const props = defineProps({
    content: {
        type: Array,
        required: true
    },
    tld: {
        type: String,
        required: true
    }
})
</script>

<template>
    <Head>
        <title>.{{ tld }} Domain - Infos, Bedingungen & Preise</title>
        <meta name="description" content="">
        <link rel="canonical" :href="url('/domains/' + tld, 'de')">
        <link rel="alternate" hreflang="en" :href="url('/domains/' + tld, 'en')">
        <link rel="alternate" hreflang="de" :href="url('/domains/' +tld, 'de')">
    </Head>
    <div>
        <section-hero :title="`.${tld} Domain <br> Infos, Bedingungen & Preise`"
                      :subtitle="`Erfahren Sie alles Wichtige über die .${tld} Domain – von den Kosten über die Registrierung bis hin zu den besten Einsatzmöglichkeiten. Finden Sie heraus, ob diese Domainendung zu Ihrem Projekt passt.`"
        />

        <template v-for="module in content">
            <section-half-text v-if="module.type === 'section-half-text'"
                               v-bind="module.data"
            />
            <section-text-with-flat-cards v-if="module.type === 'section-text-with-flat-cards'"
                                          v-bind="module.data"
            />
            <section-simple-text v-if="module.type === 'simple-text'"
                                 v-bind="module.data"
            />
            <section-text-with-accordion v-if="module.type === 'text-with-accordion'"
                                          v-bind="module.data"
            />
        </template>
    </div>
</template>
